module.exports = __webpack_public_path__ + "img/24.1668fa09.jpg";